export function formatDate(duration: string) {
  const hrs = duration.split(":")[0]
  const mins = duration.split(":")[1]
  const seconds = duration.split(":")[2]
  let dur = ""
  if (hrs != "00") {
    dur += hrs + ":" + mins + ":"
  } else {
    if (mins == "00") {
      dur += "0:"
    } else {
      if (mins.charAt(0) == "0") {
        dur += mins.charAt(1) + ":"
      } else {
        dur += mins + ":"
      }
    }
  }
  dur += seconds.split(".")[0]
  return dur
}
